import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";

const HealthAndSanitationSection = (props) => {
  return (
    <React.Fragment>
      <Row>
        <Col md={12} lg={6} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Health and Sanitation practices at the Entry Point
            </div>
            <NavLink to="/edithealthandsenitation" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_health_and_sanitization_entrypoint.map(
                (data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                }
              )}
          </div>
        </Col>
        <Col md={12} lg={6} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Health and Sanitation practices inside the Facility
            </div>
            <NavLink to="/edithealthandsenitationFacility" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_health_and_sanitization_facility.map(
                (data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                }
              )}
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={12} lg={6} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Health and Sanitation practices for Services and Handling process
            </div>
            <NavLink to="/edithealthandsenitationfoodhandling" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_health_and_sanitization_food_handling.map(
                (data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                }
              )}
          </div>
        </Col>
        <Col md={12} lg={6} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Health and Sanitation practices for your Employees in your
              Business Establishment
            </div>
            <NavLink to="/edithealthandsenitationemployees" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_health_and_sanitization_employees.map(
                (data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                }
              )}
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={12} lg={6} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Health and Sanitation practices for Health and Safety
            </div>
            <NavLink to="/edithealthandsenitationSafety" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_health_and_sanitization_health_safety.map(
                (data, index) => {
                  return (
                    <React.Fragment key={index}>{data.title}, </React.Fragment>
                  );
                }
              )}
          </div>
        </Col>
      </Row>
      <hr />
      <Row className="pb-5">
        <Col md={12} lg={8} xl={7} className="pb-4">
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">
              Facility maintained as per Health and Hygiene standards and any
              COVID-19 protocol
            </div>
            <NavLink to="/edithealthandsenitationprotocol" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            Key Points That Your Customers Must Be Aware Of: <br />
            <br />
            {props.vendor && props.vendor.discription}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default HealthAndSanitationSection;
